"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavItem", {
    enumerable: true,
    get: function() {
        return NavItem;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _ri = require("react-icons/ri");
const _NavContext = require("../../contexts/NavContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const placementDirection = (placement)=>placement.startsWith("top") || placement.startsWith("bottom") ? "vertical" : "horizontal";
const NavItem = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { noMargin = false, selected = false, showTick = true, disabled = false, nestedItemHasFocus = false, icon: Icon, rightIcon: RightIcon, children, nestedMenu, nestedMenuPlacement, actionButton, className, variant, ...props } = param;
    const { fontWeight } = (0, _react.useContext)(_NavContext.NavContext);
    const { spacers, colors, borderRadius } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        role: "option",
        tabIndex: !disabled && props.onClick != null ? 0 : undefined,
        onKeyDown: (e)=>{
            var _props_onKeyDown;
            if (e.key === "Enter" && !disabled) {
                e.target.dispatchEvent(new Event("click", {
                    bubbles: true
                }));
            }
            (_props_onKeyDown = props.onKeyDown) === null || _props_onKeyDown === void 0 ? void 0 : _props_onKeyDown.call(props, e);
        },
        ...props,
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "nav-item ".concat(className !== null && className !== void 0 ? className : "", " ").concat(disabled ? "disabled" : "", " ").concat(nestedItemHasFocus ? "focused" : ""))
    }, nestedMenuPlacement != null && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "hover-bridge ".concat(placementDirection(nestedMenuPlacement))
    }), Icon != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "icon"
    }, /*#__PURE__*/ _react.default.createElement(Icon, {
        size: 16,
        color: variant === "danger" ? colors.danger : "default",
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ])
    })), /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "text"
    }, children), (actionButton != null || selected && showTick) && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "tick"
    }, actionButton != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "actions"
    }, actionButton), selected && showTick && /*#__PURE__*/ _react.default.createElement(_ri.RiCheckLine, {
        color: "#0032E1",
        size: 16
    })), RightIcon != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ]) + " " + "icon-right"
    }, /*#__PURE__*/ _react.default.createElement(RightIcon, {
        size: 16,
        color: variant === "danger" ? colors.danger : "default",
        className: _style.default.dynamic([
            [
                "97b9297f382c1737",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    selected ? colors.lightHover : "none",
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    selected ? colors.lightHover : colors.grayscale_5,
                    selected ? spacers.s2 : spacers.s0
                ]
            ]
        ])
    })), nestedMenu), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "97b9297f382c1737",
        dynamic: [
            spacers.s3,
            borderRadius,
            noMargin ? "none" : "0 ".concat(spacers.s3),
            fontWeight === "light" ? "initial" : "500",
            spacers.s2,
            selected ? colors.lightHover : "none",
            spacers.s3,
            colors.primary,
            spacers.s3,
            selected ? colors.lightHover : colors.grayscale_5,
            selected ? spacers.s2 : spacers.s0
        ]
    }, ".nav-item.__jsx-style-dynamic-selector{cursor:pointer;padding:".concat(spacers.s3, ";text-align:left;-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";margin:").concat(noMargin ? "none" : "0 ".concat(spacers.s3), ";font-weight:").concat(fontWeight === "light" ? "initial" : "500", ";font-size:12px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:").concat(spacers.s2, ";background:").concat(selected ? colors.lightHover : "none", ";white-space:nowrap}.disabled.__jsx-style-dynamic-selector{opacity:.5;pointer-events:none}.text.__jsx-style-dynamic-selector{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}.icon.__jsx-style-dynamic-selector{margin-right:").concat(spacers.s3, ";color:").concat(colors.primary, "}.icon-right.__jsx-style-dynamic-selector{margin-left:auto}.tick.__jsx-style-dynamic-selector{margin-left:auto;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding-left:").concat(spacers.s3, "}.nav-item.__jsx-style-dynamic-selector:hover,.nav-item.__jsx-style-dynamic-selector:focus,.nav-item.focused.__jsx-style-dynamic-selector{background:").concat(selected ? colors.lightHover : colors.grayscale_5, "}.nav-item.__jsx-style-dynamic-selector:focus,.nav-item.focused.__jsx-style-dynamic-selector{outline:none}.hover-bridge.__jsx-style-dynamic-selector{display:none}.nav-item.__jsx-style-dynamic-selector:hover>.hover-bridge.__jsx-style-dynamic-selector,.nav-item.__jsx-style-dynamic-selector:focus>.hover-bridge.__jsx-style-dynamic-selector,.nav-item.focused.__jsx-style-dynamic-selector>.hover-bridge.__jsx-style-dynamic-selector{display:block}.hover-bridge.__jsx-style-dynamic-selector{position:absolute;background:transparent;left:0;width:100%;height:-webkit-calc(1rem + 16px);height:-moz-calc(1rem + 16px);height:calc(1rem + 16px)}.hover-bridge.vertical.__jsx-style-dynamic-selector{height:-webkit-calc(1rem + 24px);height:-moz-calc(1rem + 24px);height:calc(1rem + 24px)}.actions.__jsx-style-dynamic-selector{padding-right:").concat(selected ? spacers.s2 : spacers.s0, "}")));
});
NavItem.displayName = "NavItem";

//# sourceMappingURL=NavItem.js.map